import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { getLessonById } from '../data/marriageLessons';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import Seo from './Seo';
import PracticingSafeTechGate from './PracticingSafeTechGate';

const LessonDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const lesson = id ? getLessonById(id.replace(',', '')) : null;

  if (!lesson) {
    return (
      <Container maxWidth="lg">
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Lesson not found
          </Typography>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/marriage/lessons')}
          >
            Back to Lessons
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Seo
        title={lesson.title}
        description={lesson.description}
        path={`/marriage/lessons/${lesson.id}`}
      />
      {/* Back Button */}
      <Box sx={{ mt: 2, mb: 3 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/marriage/lessons')}
        >
          Back to Lessons
        </Button>

        {lesson.id === 'practicing-safe-tech' ? (
          <PracticingSafeTechGate />
        ) : (
          lesson.content && (
            <div dangerouslySetInnerHTML={{ __html: lesson.content }}></div>
          )
        )}
      </Box>
    </Container>
  );
};

export default LessonDetail;
